var _a;
import { createActions } from 'redux-actions';
export var getStores = (_a = createActions('GET_STORES', 'GET_STORES_COMPLETE'), _a.getStores), getStoresComplete = _a.getStoresComplete;
